import { type ReactNode } from 'react';
import { formatUSD } from '../utils/payment-formatters';
import type { CycleTotal } from '../hooks/use-cycle-totals';

function BreakdownLine({
  label,
  amount,
  negative = false,
}: {
  label: string;
  amount: number;
  negative?: boolean;
}): ReactNode {
  if (!amount) return null;
  const display = negative ? `-${formatUSD(amount)}` : formatUSD(amount);
  const cls = negative ? 'text-error' : 'text-text-secondary';
  return (
    <div className="flex justify-between gap-md text-[11px] text-text-tertiary">
      <span>{label}</span>
      <span className={`font-mono tabular-nums ${cls}`}>{display}</span>
    </div>
  );
}

function TotalLine({ c }: { c: CycleTotal }): ReactNode {
  return (
    <div className="mt-1 flex justify-between gap-md border-t border-white/[0.06] pt-1 text-[11px]">
      <span className="text-text-secondary">
        {c.total_leads.toLocaleString('es-ES')} creadores
      </span>
      <span className="font-mono font-medium tabular-nums text-text-primary">
        {formatUSD(c.total_eur)}
      </span>
    </div>
  );
}

export function CycleBreakdownDetail({ c }: { c: CycleTotal }): ReactNode {
  const b = c.breakdown;
  return (
    <tr className="border-t border-white/[0.04] bg-white/[0.015]">
      <td colSpan={4} className="px-md py-md">
        <div className="space-y-1.5">
          <BreakdownLine label="Creadores" amount={b.base_earnings} />
          <BreakdownLine label="Top 3" amount={b.ranking_bonus} />
          <BreakdownLine label="Bonus equipo" amount={b.group_bonus} />
          <BreakdownLine label="Bonus velocidad" amount={b.race_bonus} />
          <BreakdownLine
            label={`Sanciones (${c.sanctions_count})`}
            amount={b.sanctions}
            negative
          />
          <TotalLine c={c} />
        </div>
      </td>
    </tr>
  );
}
